import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../CSS/style.css";
import axios from "axios";
import strings from "../String";

const TransparancyNote = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let checkTheme = document.getElementById("root");
    if (checkTheme.classList.contains("dark-mode")) {
      checkTheme.classList.remove("dark-mode");
    }
  });

  // useEffect(() => {
  //   // Load remembered email from local storage
  //   const themeColor = localStorage.getItem('themeColor');
  //   console.log("Inside Dark Mode")
  //   //const rememberedPassword=localStorage.getItem('rememberedPassword');
  //   if (themeColor==='light_mode') {
  //     console.log("Inside Dark Mode")
  //     document.body.classList.add('dark-mode');
  //   }
  //   else{
  //     document.body.classList.remove('dark-mode');
  //   }
  // }, []);
  
  return (
    <section class="bg-white">
    <div class="container eulaDocMain">
      <div class="row headerLogo">
        <div class="col">
        <div class="eulaDocCopilotDiv" id="chat-header">
              <img
                src="Img/cimatron-logo-720x177.png"
                alt="Cimatron-logo"
                className="img-fluid d-block eulaDocLogo"
              /> <div class="vr"></div> <img
                src="Img/copilot-icon-text-bubble-black-512.png"
                alt="copilot-icon-text-bubble-white"
                className="eulaDocCopilot-icon" id="copilot-icon"
              /> <h3 class="px-2">Cimatron Copilot</h3>
            </div>
        </div>
      </div>
      <div class="row eula-content">
        <div class="col">
          <div class="pb-2">
            <h1>TRANSPARENCY NOTE</h1>
            <hr />
          </div>
          <div class="pb-2">
            <p>
              This Transparency Note has been prepared for the purpose of
              providing information about CIMATRON AI COPILOT to users and
              customers of CIMATRON AI COPILOT. The terms of use of the CIMATRON
              AI COPILOT (including e.g. legal disclaimer) (“Terms of Use”) are
              included as a schedule to the{" "}
              <a href="/end-user-license-agreement">
                end user license agreement of CIMATRON (“EULA”)
              </a>{" "}
              and also available, as updated from time to time, via this link,{" "}
              <a href="/schedule-a-terms-and-conditions">Terms of Use</a>. The
              Terms of Use are accepted by the licensee in connection with
              acceptance of the EULA and also accepted and agreed to, as updated
              from time to time, via the continued use of CIMATRON AI COPILOT.
            </p>
            <p>
              CIMATRON AI COPILOT is still a BETA software and subject to
              continuous testing and updating. This Transparency Note may be
              updated by CIMATRON from time to time to reflect any changes made
              by CIMATRON and its affiliates and CIMATRON reserves the right to,
              at CIMATRON’s sole discretion, update and modify this Transparency
              Note at any time without obtaining consent from You or the
              licensee of the SOFTWARE. Such changes will take immediate effect
              upon publication and we encourage You to regularly review this
              Transparency Note to stay informed about any updates. Your
              continued use of our services after changes signifies Your
              acceptance and acknowledgment of any updates to the Transparency
              Note.
            </p>
            <h3>
              PURPOSE AND USE OF CIMATRON AI COPILOT AND FINETUNING OF CIMATRON
              AI COPILOT
            </h3>
            <hr />
            <p>
              CIMATRON AI COPILOT is based and built by CIMATRON and its
              affiliates utilizing Azure Open AI Service. For the transparency
              note for Azure Open AI Service, please refer to the following
              link: following link:{" "}
              <a
                href="https://eur01.safelinks.protection.outlook.com/?url=https%3A%2F%2Flearn.microsoft.com%2Fen-us%2Flegal%2Fcognitive-services%2Fopenai%2Ftransparency-note%3Fcontext%3D%252Fazure%252Fai-services%252Fopenai%252Fcontext%252Fcontext%26tabs%3Dtext&data=05%7C02%7Cjohanna.nordahl%40sandvik.com%7Cf05e51b48b7040900e1908dc9c46b381%7Ce11cbe9cf68044b99d42d705f740b888%7C0%7C0%7C638557074685092780%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=FS8K2xH0RDZfc83YEgte9N5ZCNzX7AEDkydJEOaseE8%3D&reserved=0"
                target="_blank"
              >
                Transparency Note for Azure OpenAI - Azure AI services |
                Microsoft Learn
              </a>
            </p>
            <p>
              The model provided by Azure Open AI Service has been utilized by
              CIMATRON and its affiliates to access the CIMATRON manuals, books,
              documentation, and other materials regarding the SOFTWARE that
              CIMATRON or its affiliates own the intellectual property rights to
              (“Documentation”).
            </p>
            <p>
              CIMATRON AI COPILOT is intended to provide you with automatically
              generated answers and guidance regarding the technical usage of
              CIMATRON based on the content of the Documentation as a response
              to Your questions/prompts. The base large language model has been
              utilized to provide links to Documentation used to respond to Your
              questions/prompts.
            </p>
            <p>
              CIMATRON AI COPILOT may only be used for the purpose of asking
              questions about the content of the Documentation and should always
              be used in accordance with applicable laws and regulations.{" "}
            </p>

            <h4>INPUTS/PROMPTS </h4>
            <hr />
            <p>
              The licensee retains the ownership and intellectual property
              rights to any data or information that is owned by the licensee
              and provided by its users in CIMATRON AI COPILOT as input or
              feedback (“User Data”).{" "}
            </p>
            <p>
              You are not allowed to include any proprietary or confidential
              data belonging to any third party in the prompts or feedback that
              You submit in or to CIMATRON AI COPILOT. Additionally, and for the
              avoidance of any doubt, the free text fields available to submit
              prompts should not be used to enter any prompts, including any
              personal data.
            </p>
            <p>
              You acknowledge and agree that CIMATRON AI COPILOT collects,
              stores, processes, uses, transmits, and discloses User Data in
              accordance with the following and for the following purposes:
            </p>
            <ul>
              <li>
                CIMATRON AI COPILOT is based on and build with the third party
                feature Azure OpenAI Service that is fully controlled by
                Microsoft; Microsoft hosts the OpenAI models in Microsoft’s
                Azure environment and User Data is therefore processed by
                Microsoft and its affiliates and suppliers. Microsoft processes
                User Data contained in Your prompts/input and generated content.
              </li>
              <li>
                User Data (prompts) and generated content (output/completions)
                may be recorded by Azure OpenAI for security scanning and abuse
                monitoring by Microsoft but User Data is not used by Microsoft
                to improve any products or services of Microsoft. See further
                information about data processing of Microsoft and its abuse
                monitoring process here{" "}
                <a
                  href="https://learn.microsoft.com/en-us/legal/cognitive-services/openai/data-privacy?context=%2Fazure%2Fcognitive-services%2Fopenai%2Fcontext%2Fcontext"
                  target="_blank"
                >
                  Data, privacy, and security for Azure OpenAI Service - Azure
                  AI services | Microsoft Learn
                </a>
                .
              </li>
              <li>
                CIMATRON and its affiliates record certain User Data and
                reserve the right to use such User Data for the purposes of its
                product development, improvement of products and services, and
                quality assurance. For the aforementioned purpose, the detailed
                content of the user inputs/prompts and related
                outputs/completions are currently recorded by CIMATRON for
                approximately 6 months. If You have utilized any of our feedback
                channels (e.g. by clicking the thumbs down function at the
                bottom of the chat window) Your User Data may be stored for a
                longer period of time to give us sufficient time to analyse and
                process Your feedback. Allowing CIMATRON and affiliates to
                utilize User Data for the handling of feedback, product
                development, improvement of products and services is a
                requirement for use of CIMATRON AI COPILOT and it is not
                possible to opt out of having User Data recorded and used for
                the above purposes.
              </li>
              <li>
                To utilize CIMATRON AI COPILOT personal data about You will be
                recorded and processed. For this purpose a{" "}
                <a href="/schedule-a1-data-processing-agreement">
                  DPA (data processing agreement)
                </a>{" "}
                is a part of the end user license agreement entered into with
                the licensee of the SOFTWARE. However, to the extent that
                CIMATRON determines the purposes and means of the personal data
                processing, such as when we are using User Data for developing
                CIMATRON AI COPILOT, CIMATRON becomes the controller for such
                processing and is, consequently, solely responsible for the
                lawfulness of such processing as controller under Applicable
                Data Protection Laws. For information about how CIMATRON process
                personal data that CIMATRON is the controller for, please refer
                to Section 2 of the EULA and our{" "}
                <a
                  href="https://www.cimatron.com/en/about-this-site/privacy/privacy-statement"
                  target="_blank"
                >
                  Privacy Notice
                </a>
                .{" "}
              </li>
            </ul>
            <h4>OUTPUT/COMPLETIONS</h4>
            <hr />
            <p>
              As noted above, the CIMATRON AI COPILOT is based on and built by
              utilizing Azure Open AI Service. The output/completions of
              CIMATRON AI COPILOT is based on the Documentation and the
              ownership and intellectual property rights to the output data and
              data sources remain with CIMATRON or its affiliates.
            </p>
            <p>
              You may use the output data that you receive from CIMATRON AI
              COPILOT solely in connection with the use of the SOFTWARE and
              provided only that the licensee has an active license to the
              SOFTWARE and at all times subject to the Terms of Use.
            </p>
            <p>
              Even though CIMATRON has access to all input and output data and
              generally aims to continuously work with this data and any
              feedback received to improve the quality of CIMATRON AI COPILOT,
              You understand and acknowledge that the output data of CIMATRON AI
              COPILOT is automatically generated and not checked for accuracy by
              any human before or after being generated. CIMATRON AI COPILOT
              cannot be seen as a replacement for Your own judgment and
              responsibility, and You should check the accuracy and completeness
              of the output data before relying on it as the output/completions
              may include inaccurate, incomplete answers or answers including
              errors. You agree to use CIMATRON AI COPILOT at Your own risk and
              discretion considering that it’s a user aid tool.
            </p>
            <h3>SUPPORT AND FEEDBACK ABOUT CIMATRON AI COPILOT </h3>
            <hr />
            <p>
              For support or questions regarding CIMATRON AI COPILOT, please
              reach out to{" "}
              <a href="mailto:guy.benveniste@cimatron.com">
                guy.benveniste@cimatron.com
              </a>{" "}
            </p>
            <p>
              To give specific feedback about CIMATRON AI COPILOT, please use
              the thumbs down buttons at the bottom of the chat window. This
              will help us improve CIMATRON AI COPILOT and make it more useful
              for You and other customers and users.{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
    </section>
  );
};

export default TransparancyNote;
